import { CarouselPaginationType, CarouselSlotName } from '@/ui-kit/components/carousel/enums';

export const GalleryEvent = {
  ImageClick: 'imageClick',
};
export const ImageGallerySlotName = {
  ...CarouselSlotName,
};
export const ImageGalleryPaginationType = {
  ...CarouselPaginationType,
};
export const ImageGalleryRef = {
  PreviousButton: 'previousButton',
  NextButton: 'nextButton',
};
export const ImageGalleryPropsEventType = {
  ActiveIndexChange: 'activeIndexChange',
};
